module.exports = __webpack_public_path__ + "img/tema-1-6.1d52b6f8.svg";